/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

export const trackPages = {
    TrackDetailPage: () => import('@/track/TrackDetailPage'),
    trackSeeAll: () => import('@/seeAll/trackSeeAll'),
}
